import { render } from "./roomConversation.vue?vue&type=template&id=252a76b2&scoped=true"
import script from "./roomConversation.vue?vue&type=script&lang=js"
export * from "./roomConversation.vue?vue&type=script&lang=js"

import "./roomConversation.vue?vue&type=style&index=0&id=252a76b2&scoped=true&lang=css"

import exportComponent from "D:\\git\\tsunagaru-app\\public\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-252a76b2"]])

export default __exports__